module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow@2x-1bb30482f1df9bca8b9790ae9cdb37e3.png";